export default __webpack_public_path__ + "PDF_24.png";